module.exports = __webpack_public_path__ + "img/RS.74a720f7.svg";